import './App.css';
import { Link } from 'react-router-dom';

function Terms() {
  return (
    <div className="App">
      <nav>
        <Link to="/" className="logo" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
          <img src="/iconyomuya.png" alt="Yomiya" style={{ height: '24px', width: '24px', marginRight: '8px' }} />
          Yomiya
        </Link>
        <ul className="nav-links">
          <li><Link to="/#features">Features</Link></li>
          <li><Link to="/#use-cases">For You</Link></li>
          <li><Link to="/#testimonials">Stories</Link></li>
        </ul>
      </nav>

      <section style={{ maxWidth: '800px', margin: '0 auto', padding: '4rem 2rem' }}>
        <h1>Yomiya – Terms & Conditions</h1>
        <p style={{ color: '#666', marginBottom: '2rem' }}>Effective Date: January 2025</p>
        
        <div style={{ lineHeight: '1.8', color: '#333' }}>
          <p>
            These Terms and Conditions ("Terms") form a legally binding agreement between you ("User") and Proksi Yazılım ve Tasarım Hizmetleri Bilgisayar İthalat İhracat Ticaret Limited Şirketi ("Proksi Yazılım," "we," "our"), located at Teknopark Ankara, regarding your use of the Yomiya web application and related services (the "Service" or "Services").
          </p>
          
          <p>
            By accessing or using Yomiya, you agree to these Terms and our Privacy Policy. If you do not agree, you must stop using Yomiya immediately.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>1. Description of Service</h2>
          <p>
            Yomiya is a text-to-speech service that transforms written text into natural, calm speech. The Service allows you to:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1.5rem' }}>
            <li>Convert text into natural-sounding speech</li>
            <li>Listen to text content in multiple languages</li>
            <li>Control speech speed and voice selection</li>
            <li>Access the Service across multiple devices (desktop, tablet, mobile)</li>
          </ul>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>2. Eligibility</h2>
          <p>
            Yomiya is available to users of all ages. By using the Service, you represent that you have the legal capacity to enter into this agreement. If you are under 18, you confirm that you have parental or guardian consent to use the Service.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>3. Acceptable Use</h2>
          <p>You agree to use Yomiya only for lawful purposes. You must not:</p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1.5rem' }}>
            <li>Use the Service to generate content that is illegal, harmful, defamatory, or infringes on others' rights</li>
            <li>Attempt to reverse-engineer, decompile, or extract the Service's algorithms or technology</li>
            <li>Use automated systems to access the Service in a manner that could harm or overload our servers</li>
            <li>Impersonate others or use the Service to create misleading or fraudulent content</li>
            <li>Violate any local, national, or international laws or regulations</li>
          </ul>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>4. User Content</h2>
          <p>
            You retain all ownership rights to any text content you input into Yomiya ("User Content"). By using the Service, you grant Proksi Yazılım a limited, non-exclusive license to process your User Content solely for the purpose of providing the text-to-speech conversion service. We do not store, track, or share your text content as stated in our Privacy Policy.
          </p>
          <p>
            You are solely responsible for ensuring that any User Content you provide does not violate any third-party rights, including copyright, trademark, or privacy rights.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>5. Generated Audio Content</h2>
          <p>
            Any audio content generated by Yomiya from your text input ("Generated Audio") is provided to you for your personal or commercial use, subject to these Terms and applicable laws. Proksi Yazılım does not claim ownership of Generated Audio. However, you may not use Generated Audio in ways that violate these Terms or applicable laws.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>6. Privacy and Data</h2>
          <p>
            Your privacy is important to us. As stated in our Privacy Policy, we do not store, track, or share the text content you input into Yomiya. We may collect minimal usage data (such as device type and app version) to improve the Service, but we do not collect or store your actual text content. For more details, please review our Privacy Policy.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>7. Service Availability</h2>
          <p>
            Yomiya requires an internet connection to function. We strive to provide reliable service but do not guarantee uninterrupted or error-free operation. We may temporarily suspend the Service for maintenance, updates, or technical issues without prior notice.
          </p>
          <p>
            We reserve the right to modify, suspend, or discontinue any part of the Service at any time, with or without notice.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>8. Subscriptions and Payments</h2>
          <p>
            If Yomiya offers premium features or subscriptions, such services will be clearly indicated. Subscriptions and payments (if applicable) may be managed through third-party payment processors. Any subscription terms, billing, and refund policies will be disclosed at the time of purchase. Subscriptions may auto-renew unless canceled according to the terms provided at purchase.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>9. Intellectual Property</h2>
          <p>
            All intellectual property rights in Yomiya, including but not limited to the software, algorithms, text-to-speech technology, user interface, branding, and documentation, are owned by Proksi Yazılım or its licensors. You may not copy, modify, distribute, or create derivative works of the Service without our prior written permission.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>10. Third-Party Services</h2>
          <p>
            Yomiya may integrate with third-party services (such as analytics tools or payment processors). These services have their own terms and privacy policies, which you should review. We are not responsible for the practices of third-party services.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>11. Warranty Disclaimer</h2>
          <p>
            Yomiya is provided "as is" and "as available" without any warranties, express or implied. We do not guarantee that the Service will be uninterrupted, error-free, or meet your specific requirements. The quality of generated speech may vary based on text content, language, and other factors.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>12. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, Proksi Yazılım shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of or inability to use Yomiya. Our total liability for any claim shall not exceed the amount you paid for the Service (if any) in the twelve (12) months preceding the claim, or $50, whichever is greater.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>13. Indemnification</h2>
          <p>
            You agree to defend, indemnify, and hold harmless Proksi Yazılım from any claims, damages, or liabilities arising from your use of Yomiya, your User Content, your violation of these Terms, or your violation of any third-party rights.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>14. Termination</h2>
          <p>
            We may suspend or terminate your access to Yomiya at any time, with or without cause or notice, if you violate these Terms or for any other reason we deem necessary. You may stop using the Service at any time.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>15. Changes to Terms</h2>
          <p>
            We may revise these Terms from time to time. The latest version will be posted at https://yomiya.proksiyazilim.com/terms. Your continued use of Yomiya after changes are posted constitutes your acceptance of the updated Terms. If you do not agree to the changes, you must stop using the Service.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>16. Governing Law and Dispute Resolution</h2>
          <p>
            These Terms are governed by the laws of the Republic of Turkey. Any disputes arising from these Terms or your use of Yomiya shall be resolved through good-faith negotiation. If negotiation fails, disputes shall be subject to the exclusive jurisdiction of the courts of Ankara, Turkey.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>17. Contact Us</h2>
          <p>If you have questions about these Terms, please contact us at:</p>
          <p>
            <strong>support@proksiyazilim.com</strong><br />
            Proksi Yazılım ve Tasarım Hizmetleri Bilgisayar İthalat İhracat Ticaret Limited Şirketi<br />
            Teknopark Ankara, Turkey
          </p>
          <p style={{ marginTop: '2rem', color: '#666', fontSize: '0.9rem' }}>
            © 2025 Proksi Yazılım. All rights reserved.
          </p>
        </div>

        <div style={{ marginTop: '3rem', paddingTop: '2rem', borderTop: '1px solid #eee' }}>
          <Link to="/" style={{ color: '#2ecc71', textDecoration: 'none' }}>← Back to Home</Link>
        </div>
      </section>

      <footer>
        <p>&copy; 2025 Yomiya. Made with care for real people.</p>
        <p
          style={{
            marginTop: '1rem',
            fontSize: '0.9rem',
          }}
        >
          <Link to="/privacy">Privacy</Link> •{' '}
          <Link to="/terms">Terms</Link> •{' '}
          <a href="https://yomiya.proksiyazilim.com">Contact</a> •{' '}
          <a href="https://yomiya.proksiyazilim.com">Blog</a>
        </p>
      </footer>
    </div>
  );
}

export default Terms;
